import { render, staticRenderFns } from "./BillingTab.vue?vue&type=template&id=2323dfee&scoped=true"
import script from "./BillingTab.vue?vue&type=script&lang=js"
export * from "./BillingTab.vue?vue&type=script&lang=js"
import style0 from "./BillingTab.vue?vue&type=style&index=0&id=2323dfee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2323dfee",
  null
  
)

export default component.exports